var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewWishlist = function SvgNewWishlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "new-wishlist_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 47.03 43.61",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".new-wishlist_svg__cls-1{fill:#35938b}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.14 13.92A16.1 16.1 0 0 0 3.37 21c.16.34 20.09 22.6 20.09 22.6S43.39 21.35 43.55 21a16.1 16.1 0 0 0 3.23-7.09c0-.19 0-.38.07-.57H.07c.02.2.04.39.07.58M35.57 0c-4.44 0-9 3-12 6.27C20.44 3 15.9 0 11.46 0A11 11 0 0 0 0 11.35h47A11 11 0 0 0 35.57 0",
    className: "new-wishlist_svg__cls-1"
  })));
};
export default SvgNewWishlist;